import React from 'react';

/**
 * IGNITE brand mark — spark/pulse "I" with an ECG waveform evolving into
 * connected neural-network nodes. Cambridge navy / blue with a turquoise
 * accent representing AI and digital technologies.
 *
 * Colours pulled from the site's Cambridge palette:
 *  - Navy:       #133844
 *  - Slate:      #232830
 *  - Turquoise:  #8EE8D8 (accent — AI / digital)
 *  - Ember:      #F5B342 (spark tip on the 'I')
 */
export default function IgniteLogo({
  height = 44,
  variant = 'full', // 'full' = word + mark, 'mark' = spark only
  onDark = false,
  className = '',
}) {
  const width = variant === 'mark' ? height : height * 4.6;
  const wordColour = onDark ? '#FFFFFF' : '#232830';
  const barColour = onDark ? '#FFFFFF' : '#232830';
  const pulseColour = onDark ? '#8EE8D8' : '#133844';
  return (
    <svg
      viewBox={variant === 'mark' ? '0 0 60 60' : '0 0 260 60'}
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="IGNITE"
    >
      <defs>
        <linearGradient id="ig-spark" x1="0" x2="0" y1="1" y2="0">
          <stop offset="0%" stopColor="#133844" />
          <stop offset="60%" stopColor="#8EE8D8" />
          <stop offset="100%" stopColor="#F5B342" />
        </linearGradient>
      </defs>

      {/* Mark: ECG pulse → neural nodes composition around a stylised "I" */}
      <g transform="translate(4, 8)">
        {/* baseline pulse */}
        <path
          d="M0 30 L10 30 L14 20 L18 40 L22 30 L28 30"
          fill="none"
          stroke={pulseColour}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* stylised "I" — vertical bar with a spark tip */}
        <rect x="30" y="12" width="4" height="30" rx="1" fill={barColour} />
        <circle cx="32" cy="8" r="3.5" fill="url(#ig-spark)" />
        {/* small flame flicker to the right of the spark */}
        <path
          d="M35 6 Q37 3 35 0 Q39 3 38 8 Z"
          fill="#F5B342"
          opacity="0.85"
        />
        {/* neural network nodes on the right, connected */}
        <g stroke="#8EE8D8" strokeWidth="1.2" fill={pulseColour}>
          <line x1="34" y1="18" x2="46" y2="12" />
          <line x1="34" y1="26" x2="48" y2="26" />
          <line x1="34" y1="34" x2="46" y2="40" />
          <line x1="46" y1="12" x2="48" y2="26" />
          <line x1="46" y1="40" x2="48" y2="26" />
          <circle cx="46" cy="12" r="2.6" />
          <circle cx="48" cy="26" r="2.6" />
          <circle cx="46" cy="40" r="2.6" />
        </g>
      </g>

      {variant === 'full' && (
        <g fontFamily="'DM Serif Display', 'EB Garamond', 'Times New Roman', serif" fontWeight="400">
          <text x="66" y="42" fontSize="34" letterSpacing="2" fill={wordColour}>
            IGNITE
          </text>
        </g>
      )}
    </svg>
  );
}
